export const handleUri = (uri: string | undefined): string => {
  if (!uri) {
    return '';
    // return ''
  }

  return uri.replace('#', '%23');
};

export const getNonce = () => {
  const j =
    Date.now().toString() + Math.floor(Math.random() * 10000).toString();
  return j;
};

export const getPageNo = (url: string) => {
  const firstIndex = url.indexOf('?page=');
  const endIndex = url.indexOf('&');
  return url.substring(firstIndex + 6, endIndex);
};

export const fetcher = (api: string, args: any) => {
  return fetch(api, args)
    .then(res => res.json())
    .then(value => {
      if (value && value.code === 10112) {
        console.log('Remove token');
        console.log(value);
        localStorage.removeItem('token');
      }
      return value;
    })
    .catch(e => console.error(api, e, args));
};

export const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#333" offset="20%" />
      <stop stop-color="#222" offset="50%" />
      <stop stop-color="#333" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#333" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;

export const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str);

export const getAssetProtocol = (type: number | undefined) => {
  switch (type) {
    case 0:
      return 'ERC-721';
    case 1:
      return 'ERC-1155';
    default:
      return 'ERC-721';
  }
};
